/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
import { BLOCKS, Document } from '@contentful/rich-text-types'
import { Type } from '@/components/common'

export const articleOverride = {
  [BLOCKS.HEADING_1]: (node: any, children: any) => {
    return (
      <Type
        as="h1"
        variant={['title-md', 'xl:title-lg']}
        className="mb-3 font-semibold"
      >
        {children}
      </Type>
    )
  },
  [BLOCKS.HEADING_2]: (node: any, children: any) => {
    return (
      <Type
        as="h2"
        variant={['title-md', 'xl:title-lg']}
        className="mb-3 font-semibold"
      >
        {children}
      </Type>
    )
  },
  [BLOCKS.PARAGRAPH]: (node: any, children: any) => {
    return (
      <Type as="p" variant="paragraph-md" className="mb-4 text-core-gray-700">
        {children}
      </Type>
    )
  },
}

export const disclaimerOverride = {
  [BLOCKS.LIST_ITEM]: (node: any, children: any) => {
    return <li className="text-2xs">{children}</li>
  },
  [BLOCKS.OL_LIST]: (node: any, children: any) => {
    return <ol className="ml-5 list-decimal text-core-gray-700">{children}</ol>
  },
  [BLOCKS.PARAGRAPH]: (node: any, children: any) => {
    return (
      <Type
        as="p"
        variant="footer"
        className="leading-relaxed text-core-gray-600"
      >
        {children}
      </Type>
    )
  },
}
